import { Navigate } from "react-router-dom";

const Contact = () => {
  return <Navigate to="/about" replace />;
};

export default Contact;
